<template>
	<v-data-table
		:items="filteredItems"
		:loading="loading"
		v-bind="$attrs"
		:items-length="totalRows"
		@update:options="index"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
	</v-data-table>
</template>

<script>
import {
	axios,
} from '../../services/axios-service.js';

/**
 *  A table component for presenting elements of a database model (table) to the user. Only retrieves data once.
 */
export default {
	name: 'ModelTable',
	props: {
		/** The indexer endpoint used to retrieve table data */
		endpoint: {
			type: String,
			required: true,
		},

		filter: {
			type: Function,
			required: false,
			default: () => {
				return true;
			}
		}
	},

	emits: [ 'items-retrieved', 'items-filtered', ],

	data () {
		return {
			items: [],
			loading: true,
			totalRows: 0,
		};
	},

	computed: {
		filteredItems () {
			return this.items.filter(this.filter);
		}
	},

	mounted () {
		this.index();
	},

	methods: {
		/**
		 * Retrieves data for table from endpoint
		 *
		 * @returns {void}
		 */
		index () {
			this.loading = true;
			axios.get(this.endpoint).then(({
				data,
			}) => {
				this.items = data.items ? data.items : data;
				this.totalRows = this.items.length;
				this.$emit('items-retrieved', this.items);
				this.$emit('items-filtered', this.filteredItems);
				this.loading = false;
			}).catch((error) => {
				window.captureException(error);
				this.loading = false;
			});
		},
	},
};
</script>
